import PrivacyContainer from "@/pages/privacy";
import { PATH_PRIVACY_POLICY } from "./paths";

const miscRoutes = [
  {
    path: PATH_PRIVACY_POLICY,
    element: <PrivacyContainer />,
  }
];

export default miscRoutes;
